/* eslint-disable */
export default {
  ringing: 'Incoming call',
  callConnected: 'Call connected',
} as const;

// @key: @#@"ringing"@#@ @source: @#@"Incoming call"@#@
// @key: @#@"callConnected"@#@ @source: @#@"Call connected"@#@
